import { useSyncExternalStore } from "react";
import {
    DEFAULT_LOBBY_SETTINGS_TAB,
    resolveLobbySettingsTab,
} from "../components/lobby-settings/lobbySettingsTabs";

let snapshot = {
    open: false,
    activeTab: DEFAULT_LOBBY_SETTINGS_TAB,
    settingsResetVersion: 0,
};

const listeners = new Set();

function emit() {
    listeners.forEach((listener) => listener());
}

export function subscribeLobbySettingsPanel(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function getLobbySettingsPanelSnapshot() {
    return snapshot;
}

export function openLobbySettingsPanel(tabId) {
    snapshot = {
        ...snapshot,
        open: true,
        activeTab: resolveLobbySettingsTab(tabId),
    };
    emit();
}

export function closeLobbySettingsPanel() {
    if (!snapshot.open) {
        return;
    }
    snapshot = {
        ...snapshot,
        open: false,
    };
    emit();
}

export function bumpLobbySettingsResetVersion() {
    snapshot = {
        ...snapshot,
        settingsResetVersion: snapshot.settingsResetVersion + 1,
    };
    emit();
}

export function setLobbySettingsPanelTab(tabId) {
    const nextTab = resolveLobbySettingsTab(tabId);
    if (snapshot.activeTab === nextTab) {
        return;
    }
    snapshot = {
        ...snapshot,
        activeTab: nextTab,
    };
    emit();
}

export function useLobbySettingsPanel() {
    return useSyncExternalStore(
        subscribeLobbySettingsPanel,
        getLobbySettingsPanelSnapshot,
        getLobbySettingsPanelSnapshot,
    );
}
